(function () {
    angular.module('app')
        .controller('FeedGridController', FeedGridController);

    FeedGridController.$inject = ['$scope', '$element', '$attrs', '$window', '$timeout'];
    function FeedGridController($scope, $element, $attrs, $window, $timeout) {
        var ctrl = this;
        $scope.$watch('params', function (newVal) {
            if (newVal) {
                ctrl.params = angular.copy(newVal);
                ctrl.params.id = $attrs.source;
                ctrl.params.featured = $attrs.featured;
                ctrl.params.includeBodyText = $attrs.hasModal;
                ctrl.params.sortType = $attrs.sortType;
                if (ctrl.params.sortAscending === undefined) {
                    ctrl.params.sortAscending = $attrs.ascending;
                }
            }
            else {
                ctrl.params = {
                    id: $attrs.source,
                    featured: $attrs.featured,
                    sortAscending: $attrs.ascending,
                    includeBodyText: $attrs.hasModal,
                    sortType: $attrs.sortType
                }
            }
        });

        ctrl.openModal = function ($event, index) {
            $event.preventDefault();
            if (ctrl.carousel) {
                ctrl.carousel.goToSlide(index, false);
            }
            this.modalOpen = true;
            $scope.$root.lockScroll = true;
        };

        ctrl.closeModal = function () {
            this.modalOpen = false;
            $scope.$broadcast('pauseVideo');
            $scope.$root.lockScroll = false;
        };

        ctrl.blockClose = function (event) {
            event.stopPropagation();
        };

        ctrl.registerCarousel = function (carousel) {
            ctrl.carousel = carousel;
        };

        ctrl.updateSlides = function (slides) {
            ctrl.modalSlides = angular.copy(slides);
            ctrl.syncAnimations();
        };

        ctrl.updateHash = function (slide) {
            if (slide) {
                $window.location.hash = slide.urlName;
            }
        };

        var clientMargin = 0;

        function getClientPos(data, index) {
            var start = Math.floor(index / data.slideData.length);
            var currentIndex = (index + Math.abs(data.slideData.length * start)) % data.slideData.length;
            var totalWidth = data.slideData.length * data.carousel.width();
            return start * totalWidth + (data.carousel.width() * currentIndex);
        }

        ctrl.slideAnimation = function (offset, index, data) {
            var width = data.carousel.width();
            var totalWidth = data.slideData.length * width;
            if (width > 0) {
                var rounds = -Math.floor((getClientPos(data, index) + offset + width) / totalWidth);
                var roundLength = data.slideData.length;
                var renderIndex = index + (rounds * roundLength);
                var pos = getClientPos(data, renderIndex);
                return {
                    x: pos + offset,
                    y: 0
                };
            }
        };

        ctrl.slideSnap = function (offset, data) {
            var slideWidth = data.carousel.width();
            var index = -Math.round(offset / slideWidth);
            return {
                index: index,
                position: -getClientPos(data, index)
            };
        };

        ctrl.syncAnimations = function () {
            if ($window.wow) {
                $timeout(function () {
                    $window.wow.sync();
                });
            }
        };
    }
})();